import {
  formatDateTime,
  ModerationOperationPill,
  ModerationStatusPill,
  sourceLabel,
  statusLabel,
  type ChangeRequest,
  type ModerationOperation,
  type Translate,
} from '@/entities/moderation';
import { InfoRow } from './review-modal-shell';

interface RequestMetaProps {
  request: ChangeRequest;
  operation: ModerationOperation;
  t: Translate;
}

/**
 * The request's identity under the modal title: what it asks (operation
 * pill), where it stands (status pill), where it came from (source) and
 * when it was submitted. Every review modal renders the same row, so the
 * create / update / delete × pending / decided split is always explicit.
 */
export function RequestMeta({ request, operation, t }: RequestMetaProps) {
  return (
    <div
      className="flex flex-wrap items-center gap-x-2 gap-y-1.5 pt-1"
      data-testid="moderation-request-meta"
    >
      <ModerationOperationPill operation={operation} t={t} />
      <ModerationStatusPill
        status={request.status}
        label={statusLabel(request.status, t)}
      />
    </div>
  );
}

/** Request metadata rendered as ordinary rows in the entity information. */
export function RequestInfo({ request, t }: Pick<RequestMetaProps, 'request' | 't'>) {
  return (
    <>
      <InfoRow
        label={t('filters.source', 'Источник')}
        value={request.source ? sourceLabel(request.source, t) : '—'}
      />
      <InfoRow
        label={t('review.submittedAt', 'Подано: {{date}}').split(':')[0] ?? ''}
        value={request.created_at ? formatDateTime(request.created_at) : '—'}
        numeric
      />
    </>
  );
}
